import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-sending-icon',
  templateUrl: './communication-sending.component.html'
})
export class CommunicationSendingComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
